import React, { useState, useEffect } from "react";
import { Group, Rect, Text } from "react-konva";
import BrandColors from "../../../../../../styles/BrandColors";
import ScoreIndicator from "../ScoreIndicator";
import RecordName from "./recordName";
import ConnectorPoint from "./connectorPoint";

const Record = (props) => {
  const {
    entityId,
    record = {},
    selected,
    onMenuClick: onMenuClickCanvas,
    hideMenu,
    onRecordInfoClick,
    hideRecordInfo,
    selectRecord,
    toggleParents,
  } = props;

  const { JLLBrandColors } = BrandColors;
  const { Red, White, Steel } = JLLBrandColors;

  const menuIconRef = React.useRef();
  const infoIconRef = React.useRef();

  const [shadowBlur, setShadowBlur] = useState(0);
  const [borderColor, setBorderColor] = useState(
    entityId === record.id ? Red.core : Steel.tint50Percent,
  );

  useEffect(() => {
    setShadowBlur(selected ? 5 : 0);
    setBorderColor(
      selected || entityId === record.id ? Red.core : Steel.tint50Percent,
    );
  }, [selected]);

  const expandClick = () => {
    toggleParents(record.id);
  };

  const onNameCLick = () => {
    window.open(`/glc/checks/viewCheck/basicinfo?id=${record.id}`, "_blank");
  };

  const onMenuClick = () => {
    const pos = menuIconRef.current.getAbsolutePosition();
    onMenuClickCanvas(record.id, pos);
  };

  const onInfoClick = () => {
    const pos = infoIconRef.current.getAbsolutePosition();
    onRecordInfoClick(record.id, pos);
  };

  const onClick = (e) => {
    if (e.target !== menuIconRef.current) {
      hideMenu();
    }
    if (e.target !== infoIconRef.current) {
      hideRecordInfo();
    }
    selectRecord(record.id);
  };

  return (
    <Group onClick={onClick} visible={!record.hide}>
      <Group>
        <ConnectorPoint record={record} onClick={expandClick} />
        <Rect
          x={record.x}
          y={record.y}
          width={record.width}
          height={record.height}
          fill={White.tint75Percent}
          shadowBlur={shadowBlur}
          stroke={borderColor}
          strokeWidth={1}
          cornerRadius={1}
        />
      </Group>
      <Group>
        <RecordName record={record} onClick={onNameCLick} />

        {record.showMenu && (
          <Text
            ref={menuIconRef}
            x={record.x + record.width - 15}
            y={record.y + 5}
            fontSize={13}
            fontFamily="Font Awesome 5 Pro"
            text={"\uf142"}
            fill="grey"
            onClick={onMenuClick}
          />
        )}

        <ScoreIndicator
          score={record.kycScore}
          validityDate={record.kycScoreValidTo}
          expired={record.kycExpired}
          label={"KYC"}
          x={record.x + 30}
          y={record.y + 50}
          expired={record.kycExpired}
        />
        <ScoreIndicator
          score={record.amlScore}
          validityDate={record.amlScoreValidTo}
          expired={record.amlExpired}
          label={"AML"}
          x={record.x + 100}
          y={record.y + 50}
          expired={record.amlExpired}
        />

        <Text
          ref={infoIconRef}
          x={record.x + 150}
          y={record.y + 50}
          fontSize={13}
          fontFamily="Font Awesome 5 Pro"
          text={"\uf059"}
          onClick={onInfoClick}
        />
      </Group>
    </Group>
  );
};

export default Record;
